export const iconFontAwesomeEditingTrashCanArrowUp = (
	<i className="fa-solid fa-trash-can-arrow-up"></i>
);
